const AGGREGATE_CALC: string = 'aggregate_calc';
const ALL_CALC: string = 'all_calc';
const COMPANY_CALC: string = 'company_calc';
const FUND_CALC: string = 'fund_calc';
const FUND_HISTORY_CALC: string = 'fund_history_calc';
const HISTORY_CALC: string = 'history_calc';
const INDEX_CALC: string = 'index_calc';
const STOCK_CALC: string = 'stock_calc';

export { AGGREGATE_CALC, ALL_CALC, COMPANY_CALC, FUND_CALC, FUND_HISTORY_CALC, HISTORY_CALC, INDEX_CALC, STOCK_CALC };
